var _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckedCircleBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 12,
    ry: 12,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 12 12)",
    fill: "#006FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4378 13.0356L9.66976 15.2675C10.1315 15.7293 10.7867 15.6898 11.3078 15.1688L16.1707 10.3059C16.6917 9.78485 16.7312 9.12964 16.2694 8.66786C15.8076 8.20607 15.1524 8.24557 14.6314 8.76659L10.6369 12.7611L9.17456 11.2988C8.71277 10.837 8.05756 10.8765 7.53654 11.3976C7.01551 11.9186 6.97602 12.5738 7.4378 13.0356Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCircleBlue);
export default __webpack_public_path__ + "static/media/checked-circle-blue.3e3c571f228167b1330412777622532b.svg";
export { ForwardRef as ReactComponent };